import React, { FC, useMemo } from 'react';
import FilterSelector from '@components/tables/core/FilterSelector';
import useProjectData from '@hooks/useProjectData';
import { transformArrayToOptions } from '@utils/helpers';

type Props = {
  onChange: (partners: string[]) => void;
  partners: string[];
};

const MAX_VISIBLE_OPTIONS = 10;

const PartnersFilterSelector: FC<Props> = ({ partners, onChange }) => {
  const [project] = useProjectData();

  const partnersOptions = useMemo(() => {
    return transformArrayToOptions(project.partners ?? []);
  }, [project]);

  return (
    <FilterSelector
      title="By outsourcing partner"
      values={partners}
      onChange={onChange as (values: (string | number)[]) => void}
      options={partnersOptions}
      expandByDefault={partnersOptions.length <= MAX_VISIBLE_OPTIONS}
    />
  );
};

export default PartnersFilterSelector;
